// src/config/tenant-routing.js
// Static map — resolves before any network call.
// FOUNDATION-PURITY-1: no tenant-specific logic in platform code.

const HOSTNAME_MAP = {
  'app.elyonsci.ai':         'elyon-demo',
  'app.ncl.elyonsci.ai':     'ncl',
  'studio.elyonsci.ai':      'elyon-demo',
  'localhost':                'elyon-demo',
  'localhost:5173':           'elyon-demo',
  '127.0.0.1':               'elyon-demo',
};

const DEFAULT_TENANT_ID = 'elyon-demo';

export function resolveTenantId(hostname) {
  // Strip port from hostname for matching
  const host = hostname.split(':')[0];
  // Full hostname match first
  if (HOSTNAME_MAP[hostname]) return HOSTNAME_MAP[hostname];
  // Host-only match
  if (HOSTNAME_MAP[host]) return HOSTNAME_MAP[host];
  // Preview deploy pattern: *.elyonsci.ai → elyon-demo
  if (hostname.endsWith('.elyonsci.ai')) return 'elyon-demo';
  // Fail-open to demo tenant — never blank-screen on unknown hostname
  return DEFAULT_TENANT_ID;
}

export const KNOWN_TENANT_IDS = Object.values(HOSTNAME_MAP)
  .filter((v, i, a) => a.indexOf(v) === i);
